
import React from 'react';
import { Button } from '@/components/ui/button';
import { Video, Twitter } from 'lucide-react';
import VideosGrid from './VideosGrid';
import TweetsSection from './TweetsSection';

interface ResourcesTabsProps {
  activeTab: 'videos' | 'tweets';
  setActiveTab: React.Dispatch<React.SetStateAction<'videos' | 'tweets'>>;
}

const ResourcesTabs = ({ activeTab, setActiveTab }: ResourcesTabsProps) => {
  return (
    <>
      <div className="flex space-x-4 mb-6">
        <Button 
          variant={activeTab === 'videos' ? 'default' : 'outline'} 
          onClick={() => setActiveTab('videos')}
          className="flex items-center gap-2"
        >
          <Video className="h-4 w-4" /> Videos
        </Button>
        <Button 
          variant={activeTab === 'tweets' ? 'default' : 'outline'} 
          onClick={() => setActiveTab('tweets')}
          className="flex items-center gap-2"
        >
          <Twitter className="h-4 w-4" /> X Posts
        </Button>
      </div>
      
      {activeTab === 'videos' ? <VideosGrid /> : <TweetsSection />}
    </>
  );
};

export default ResourcesTabs;
